<script lang="ts">
  import type { RankChange } from '../../shared/ranked';
  import { rankChangeLabel, rankLabel } from '../content/ranks';

  /** The viewer's visible rank change after a ranked match. */
  let { change }: { change: RankChange } = $props();

  const RESULT_LABELS = { win: 'Victory', loss: 'Defeat', draw: 'Draw' } as const;
</script>

<div class="rank-change" data-result={change.result}>
  <strong>{RESULT_LABELS[change.result]} · {rankChangeLabel(change)}</strong>
  <small>{rankLabel(change.after)}</small>
</div>

<style>
  .rank-change {
    display: grid;
    gap: 2px;
    margin: 12px 0;
    padding: 10px 12px;
    text-align: center;
    border: 1px solid var(--theme-accent);
    border-radius: 12px;
  }
  .rank-change small {
    color: var(--theme-muted-text);
  }
</style>
